module.exports = __webpack_public_path__ + "media/images/expert__ole-einar-bjoerndalen-f363b3f82e728bdfa5577d986d9ba051.png";